import axios from 'axios'

// 创建axios实例
// 开发环境：使用环境变量配置的API地址
// 生产环境：使用相对路径 /api，由Nginx反向代理
const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/api' : (process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api'),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 可以在这里添加token等认证信息
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    console.error('API请求错误:', error)
    return Promise.reject(error)
  }
)

// 菜单相关API
export const menuApi = {
  // 获取公开的菜单列表（只获取可见的激活菜单）
  getPublicMenus() {
    return api.get('/system/menus/public', {
      params: { active: 'true' }
    })
  },
  getPublicMenusCatalog() {
    return api.get('/system/menus/public/catalog', {
    })
  },

  // 根据菜单ID获取页面内容
  getPageContentByMenuId(menuId, language = 'zh-CN') {
    return api.get('/system/page-contents', {
      params: { 
        menuId, 
        language, 
        active: 'true'
      }
    })
  },

  // 根据菜单路径获取页面内容
  getPageContentByMenuPath(path, language = 'zh-CN') {
    return api.get(`/system/page-contents/by-path/${encodeURIComponent(path)}`, {
      params: { language }
    })
  }
}

// 页面内容API
export const pageContentApi = {
  // 获取指定菜单的页面内容
  getContentByMenu(menuId, language = 'zh-CN') {
    return api.get('/system/page-contents', {
      params: {
        menuId,
        language,
        active: 'true'
      }
    })
  },

  // 获取所有激活的页面内容
  getActiveContents(language = 'zh-CN') {
    return api.get('/system/page-contents', {
      params: {
        language,
        active: 'true'
      }
    })
  }
}

export default api
